@let showError = formControlState().invalid && formControlState().touched && displayErrorMessage();
<div class="field-label-container">
  <p class="field-label">{{ label() }}</p>
  @if (showError && errorStyle() === 'tooltip') {
    <div class="error-indicator">
      !
      <div class="error-tooltip">
        {{ displayErrorMessage() }}
      </div>
    </div>
  }
</div>
@if (inputType() === 'select') {
  <orbit-select
    [class.has-error]="showError"
    [options]="selectOptions() ?? []"
    [controller]="controller()"
    [name]="name()"
    [testId]="testId()"
    [disabled]="disabled()" />
} @else {
  <orbit-input
    [class.has-error]="showError"
    [autocomplete]="autocomplete()"
    [inputType]="$any(inputType())"
    [name]="name()"
    [testId]="testId()"
    [disabled]="disabled()"
    [placeholder]="placeholder()"
    [controller]="controller()"
    (blurred)="onInputBlur()" />
}

@if (showError && errorStyle() === 'inline') {
  <div class="error-inline">
    {{ displayErrorMessage() }}
  </div>
}
